import React from 'react'
import Container from './container'
import Nav from './nav'
import linkedin from '../images/linkedin.svg'
import facebook from '../images/facebook.svg'
import styles from './footer.module.scss'

const navItems = [
  {
    label: 'Privacy',
    to: '/privacy'
  },
  {
    label: 'Legal',
    to: '/legal'
  },
  {
    label: 'Contact',
    to: '/contact'
  },
]

const Footer = () => (
  <footer className={ styles.footer }>
    <Container className={ styles.container }>
      <p className={ styles.copy }>&copy; { new Date().getFullYear() } Rheia, LLC.</p>

      <Nav items={ navItems } alignment="center" className={ styles.nav } />

      <ul className={ styles.social }>
        <li style={{ marginTop: '-3px' }}>
          <a href="https://www.facebook.com/RheiaComfort/" target="__blank">
            <img src={ facebook } alt="facebook" />
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/rheia-llc/" target="__blank">
            <img src={ linkedin } alt="linkedin" />
          </a>
        </li>
      </ul>
    </Container>
  </footer>
)

export default Footer
